import { makeStyles, Tooltip } from '@material-ui/core'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { FC, useMemo, useState } from 'react'

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: '#E2EBFD',
    color: '#000',
    fontSize: 14,
    padding: '8px 10px'
  },
  arrow: {
    color: '#E2EBFD'
  },
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  icon: {
    fontSize: 18,
    color: '#94004A'
  },
  indicatorText: {
    marginRight: 4,
    fontSize: 12,
    color: '#94004A'
  }
}))

export interface InfoTooltipProps {
  lines: Array<string | undefined | null>
  indicatorText?: string | null
  ariaLabel?: string
  triggerClassName?: string
  iconClassName?: string
}

const InfoTooltip: FC<InfoTooltipProps> = ({
  lines,
  indicatorText,
  ariaLabel = 'info-tooltip',
  triggerClassName,
  iconClassName
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const filteredLines = useMemo(
    () => lines.filter((line): line is string => Boolean(line?.trim())),
    [lines]
  )

  if (filteredLines.length === 0) {
    return null
  }

  const triggerClasses = triggerClassName
    ? `${classes.trigger} ${triggerClassName}`
    : classes.trigger

  const iconClasses = iconClassName
    ? `${classes.icon} ${iconClassName}`
    : classes.icon

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        arrow
        interactive
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        open={open}
        onClose={() => setOpen(false)}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        title={
          <div>
            {filteredLines.map((line, index) => (
              <div key={`info-tooltip-line-${index}`}>{line}</div>
            ))}
          </div>
        }
      >
        <span
          onClick={() => setOpen(!open)}
          role='button'
          aria-label={ariaLabel}
          className={triggerClasses}
        >
          {indicatorText && (
            <span className={classes.indicatorText}>{indicatorText}</span>
          )}
          <InfoOutlinedIcon className={iconClasses} />
        </span>
      </Tooltip>
    </ClickAwayListener>
  )
}

export default InfoTooltip
